import { Injectable } from "@angular/core";
import { SelectionItem } from "~app/common/components/tree-selector/selection-item";
import { AreaSelectionMarknadsomrade, IAreaSelectionOmrade } from "~app/common/models/areaSelector";
import { Anskaffningsformer } from "~app/common/models/constants";
import { NumberUtils } from "~app/common/utils/number-utils";
import { ObjectUtils } from "~app/common/utils/object-utils";

export const validateMottagareFormat = (propertyValue: any, row: any): boolean => {
    if (!ObjectUtils.stringHasValue(propertyValue)) {
        return true;
    }

    const splittedString = propertyValue.split("-", 2);
    if (splittedString.length === 1) {
        return splittedString[0].length === 5 && NumberUtils.isNumeric(splittedString[0]);
    }

    return splittedString[0].length === 5 && NumberUtils.isNumeric(splittedString[0]) && splittedString[1].length === 5 && NumberUtils.isNumeric(splittedString[1]);
};

export const validateAvtalatMattslag = (propertyValue: any, row: any): boolean => {
    // eslint-disable-next-line sonarjs/prefer-single-boolean-return
    if ((row.anskaffningsform.some(p => p === Anskaffningsformer.Egenskog) || row.anskaffningsform.length === 0) &&
        !ObjectUtils.stringHasValue(propertyValue)) {
        return false;
    }
    return true;
};

export interface IRegelverkContraint<T> {
    key: keyof T;
    requirements: {
        maxLength?: number;
        minLength?: number;
        required?: boolean;
        customRule?: (propertyValue: any, row: any) => boolean;
        editable?: (params: any) => boolean;
        otherCellsEditedRule?: (property: any, row: any) => boolean;
    };
}

export interface ISelectorVerksamhetsOmraden extends SelectionItem {
    children?: ISelectorVerksamhetsOmraden[];
    marknadsomrade?: string;
    produktionsomrade?: string;
    resultatomrade?: string;
    text: string;
    value: string;
}

@Injectable({
    providedIn: "root"
})
export class RegelverkGridService {

    mapSelectionItemsVerksamhetsomraden(verksamhetsomrade: AreaSelectionMarknadsomrade[], selected: string[]): SelectionItem[] {
        return verksamhetsomrade.map(element => this.createTreeSelectionNode(element, selected));
    }

    private createTreeSelectionNode(node: IAreaSelectionOmrade, selected: string[]): SelectionItem {
        let children: SelectionItem[] = null;
        let partialSelected = false;
        if (node.children) {
            children = children === null ? [] : children;
            node.children.forEach((data: any) => {
                const childNode = this.createTreeSelectionNode(data, selected);
                if (childNode.selected || childNode.partialSelected) {
                    partialSelected = true;
                }
                children.push(childNode);
            });
        }

        return {
            value: node.guid,
            text: node.namn,
            selected: selected?.some(x => x === node.guid),
            partialSelected: partialSelected,
            children: children
        };
    }
}
